/**
 * Return only that options that are in the `restricted` array
 * Used when inheriting options from timeline > step or step > property.
 * Usually only the "duration" should be returned, because other options
 * from step or timeline cannot be inherited - they are step or timeline-specific
 * @param {OptionsListMapProps} global
 * @param {OptionsListMapProps} common
 * @param {OptionsListMapProps} defaults
 * @returns {OptionsListMapProps}
 */
const getRestrictedOptions = (global, common, defaults) => {
  const map = new Map();

  const restricted = /** @type {Array<keyof OptionsListObjectProps>} */ ([
    "duration",
  ]);

  if (global && common) {
    for (const name of restricted) {
      const hasOption = global.has(name);

      if (hasOption) {
        map.set(name, global.get(name));
      }
    }

    for (const name of restricted) {
      const hasOption = common.has(name);

      if (hasOption) {
        map.set(name, common.get(name));
      }
    }
  } else if (global) {
    for (const name of restricted) {
      const hasOption = global.has(name);

      if (hasOption) {
        map.set(name, global.get(name));
      }
    }
  } else if (common) {
    for (const name of restricted) {
      const hasOption = common.has(name);

      if (hasOption) {
        map.set(name, common.get(name));
      }
    }
  } else {
    for (const name of restricted) {
      const hasOption = defaults.has(name);

      if (hasOption) {
        map.set(name, defaults.get(name));
      }
    }
  }

  return map;
};

export default getRestrictedOptions;
